export default "__VITE_ASSET__BTd4kt8h__"